/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SimpleOverlay":"SimpleOverlay_z-DLz"};